export default "__VITE_ASSET__DzMH$fwz__"